import { CssBaseline } from "@material-ui/core";
import MaterialTable from "material-table";
import LabelsContext from "../../../../lang/LabelsContext";
import EnumTriggerType from "../../../../utils/enum/EnumTriggerType";
import { dateTimeView, getActionType, getReviewStatus } from "../../../../utils/Utils";
import { tableIcons } from "../../../system/material-table-utils/MaterialTableUtils";
import LogService, { LogServiceType } from "./LogService";

export default function AllManuscripts() {
  const { Labels } = LabelsContext();

  const { logList }: LogServiceType = LogService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            field: "actionTime",
            title: Labels.DATE,
            render: (rowData) => <div>{dateTimeView(rowData.actionTime)}</div>,
          },
          {
            field: "actionType",
            title: "Action type",
            render: (rowData: any) => <div>{getActionType(rowData.actionType, Labels)}</div>,
          },
          {
            field: "previousStatus",
            title: "Previous Status",
            render: (rowData: any) => <div>{getReviewStatus(rowData.previousStatus, Labels)}</div>,
          },
          {
            field: "currentStatus",
            title: "New Status",
            render: (rowData: any) => <div>{getReviewStatus(rowData.currentStatus, Labels)}</div>,
          },
          {
            title: "User",
            render: (rowData: any) => (
              <div>
                {rowData.triggerType === EnumTriggerType.USER
                  ? `${rowData.user.firstName} ${rowData.user.lastName}`
                  : "By System"}
              </div>
            ),
          },
          { field: "description", title: "Decription", cellStyle: { width: "30%" } },
        ]}
        title={""}
        data={logList}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
        }}
      />
    </>
  );
}
